import { useContext, createContext } from 'react'

/**
 * Context for triggering map data refreshes
 * Used to notify map components when plot data has changed (e.g., after creating/updating plots)
 */
export const MapRefreshContext = createContext(null)

export const useMapRefresh = () => {
  const context = useContext(MapRefreshContext)
  if (!context) {
    throw new Error('useMapRefresh must be used within MapRefreshProvider')
  }
  return context
}
